<template>
  <div>
    <b-input-group prepend="Ország" class="mb-2"
      :state="stateFor(['country_code']) && errors$addressCountryCode.length < 1"
      :invalid-feedback="errors$addressCountryCode"
    >
      <b-form-select
        id="addressCountryCode"
        v-model="address.country_code"
        :state="stateFor(['country_code']) && errors$addressCountryCode.length < 1"
        :options="countries"
        placeholder="Ország"
        required
      />
    </b-input-group>
    <b-input-group prepend="Irányítószám és város" class="mb-2">
      <b-form-input
        id="addressPostCode"
        v-model="address.post_code"
        :state="stateFor(['post_code']) && errors$addressPostCode.length < 1"
        type="text"
        placeholder="Irányítószám"
        required
      />
      <b-form-input
        id="addressCity"
        v-model="address.city"
        :state="stateFor(['city']) && errors$addressCity.length < 1"
        type="text"
        placeholder="Város"
        required
      />
    </b-input-group>
    <b-input-group prepend="Cím" class="mb-2"
      :state="stateFor(['address']) && errors$addressAddress.length < 1"
      :invalid-feedback="errors$addressAddress"
    >
      <b-form-input
        id="addressAddress"
        v-model="address.address"
        :state="stateFor(['address']) && errors$addressAddress.length < 1"
        type="text"
        placeholder="Utca, házszám"
        required
      />
    </b-input-group>
  </div>
</template>
<script>
  import FormValidation from '../../utils/mixins/FormValidation'

  export default {
    mixins: [FormValidation(['addressAddress', 'addressPostCode', 'addressCity', 'addressCountryCode'])],
    props: {
      value: {
        type: Object,
        required: true,
        default: () => ({
          city: '',
          address: '',
          post_code: '',
          country_code: '',
        })
      },
      state: {
        validator: prop => typeof prop === 'boolean' || prop === null,
        default: null
      }
    },
    data() {
      return {
        address: {
          city: '',
          address: '',
          post_code: '',
          country_code: '',
        },
        countries: [
          {
            text: 'Magyarország',
            value: 'HU'
          }
        ]
      }
    },
    watch: {
      value: {
        immediate: true,
        deep: true,
        handler(address) {
          _.assign(this.address, address)
        }
      },
      address: {
        deep: true,
        handler(address) {
          this.$emit('input', address)
        }
      }
    },
    methods: {
      stateFor(fields) {
        var state = true
        _.forEach(fields, field => {
          if(typeof this.address[field] !== 'undefined') {
            state = state && this.address[field].length > 0
          }
        })

        return state
      }
  }
  }
</script>